import type { ReactNode } from 'react'
import { landingSurfaceClass } from '@/components/landing/landingStyles'
import { cn } from '@/components/ui/cn'

interface LandingProductShellProps {
  children: ReactNode
  className?: string
  testId?: string
}

/** Unified glass panel for capabilities + closing CTA. */
export function LandingProductShell({
  children,
  className,
  testId = 'landing-product-shell',
}: LandingProductShellProps) {
  return (
    <div className="mx-auto max-w-5xl px-4 sm:px-6">
      <div className={cn(landingSurfaceClass, 'p-6 sm:p-8 lg:p-10', className)} data-testid={testId}>
        {children}
      </div>
    </div>
  )
}
